<h1 mat-dialog-title>
  {{ ("cancelBookedInvitee" | i18n) || "Gebuchten Mitarbeiter stornieren" }}
</h1>
<div
  mat-dialog-content
  *ngIf="!data.forceReason">
  <div class="row">
    <div class="col">
      <mat-form-field>
        <mat-label>{{ ("reason" | i18n) || "Grund" }}:</mat-label>
        <mat-select
          [(ngModel)]="reason"
          data-cy="cancel-reason-select">
          <mat-option
            *ngFor="let reasonOption of cancelReasons$ | async"
            [value]="reasonOption">
            <span [attr.data-cy]="'cancel-reason-option-' + reasonOption.id">
              {{ reasonOption.displayName[lang] }}
            </span>
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field
        *ngIf="reason?.enableDescription"
        class="no-extra-infix-width">
        <textarea
          [(ngModel)]="reasonDescription"
          matInput
          name="description"
          [placeholder]="('description' | i18n) || 'beschreibung' | titlecase"
          style="margin-top: 10px"></textarea>
      </mat-form-field>
      <mat-checkbox
        [(ngModel)]="informInviteeOfReason"
        name="informInvitee"
        data-cy="inform-invitee-of-cancel-reason">
        {{
          ("informInviteeOfReason" | i18n) || "Pooler über Grund informieren"
        }}
      </mat-checkbox>
    </div>
  </div>
</div>
<div mat-dialog-actions>
  <button
    mat-button
    (click)="close()">
    {{ ("close" | i18n) || "close" | uppercase }}
  </button>
  <button
    [disabled]="reason == undefined"
    mat-button
    [mat-dialog-close]="{reason, reasonDescription, informInviteeOfReason}"
    data-cy="cancel-reason-submit">
    {{ ("confirm" | i18n) || "confirm" | uppercase }}
  </button>
</div>
